/**
 * Delete Content UseCase
 *
 * Mirrors Flutter MediasRepository.deleteContent →
 * CloudFunctionsService.deleteContentStorage
 * (lib/data/repository/medias_repository.dart:353).
 */

import { MediaService } from '@/domain/services/media/mediaService';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class DeleteContentUseCase {
  private mediaService: MediaService;

  constructor(mediaService?: MediaService) {
    this.mediaService = mediaService || new MediaService();
  }

  async execute(media: UserMediaEntity): Promise<boolean> {
    try {
      return await this.mediaService.deleteContent(media.id);
    } catch (error) {
      appLogger.error('Error deleting content', 'DeleteContentUseCase.execute', { error: error as Error });
      return false;
    }
  }
}

export const deleteContentUseCase = new DeleteContentUseCase();
